import React from 'react';
import { Gem, Mountain, Armchair, Triangle, MapPin } from 'lucide-react';

const TreasuresSection = () => {
  const treasureExamples = [
    {
      icon: Armchair,
      title: "Un banc oublié",
      description: "offrant une vue exceptionnelle"
    },
    {
      icon: Mountain,
      title: "Un rocher discret",
      description: "pour observer les étoiles ou les lumières d'une ville"
    },
    {
      icon: Triangle,
      title: "Une simple colline",
      description: "idéal pour admirer les avions atterrir et décoller en toute sérénité"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full">
              <Gem className="w-8 h-8 text-white" />
            </div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-amber-900 mb-6">
            Les trésors du quotidien
          </h2>
          <p className="text-xl text-amber-700 max-w-3xl mx-auto">
            Quand l'ordinaire devient extraordinaire
          </p>
        </div>

        {/* Main Content */}
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 md:p-12 mb-12">
          <p className="text-lg text-gray-700 leading-relaxed mb-8 text-center max-w-4xl mx-auto">
            Sur Sun-Spot, <span className="text-amber-700 font-semibold">les lieux spectaculaires côtoient des trésors simples mais précieux</span> :
          </p>
          
          <div className="bg-white/70 backdrop-blur-sm rounded-xl p-8 shadow-md mb-8">
            <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
              <p>• Un banc oublié offrant une vue exceptionnelle</p>
              <p>• Un rocher discret pour observer les étoiles ou les lumières d'une ville</p>
              <p>• Une simple colline idéal pour admirer les avions atterrir et décoller en toute sérénité</p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl p-6 text-white text-center">
            <p className="text-xl font-medium leading-relaxed">
              Ce qui semble <span className="font-bold">banal peut devenir un vrai coup de cœur</span> pour d'autres utilisateurs.
            </p>
          </div>
        </div>

        {/* Examples Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {treasureExamples.map((treasure, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow duration-300 border border-gray-100">
              <div className="flex justify-center mb-6">
                <div className="p-4 bg-amber-100 rounded-full">
                  <treasure.icon className="w-8 h-8 text-amber-600" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-amber-900 mb-3">
                {treasure.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {treasure.description}
              </p>
            </div>
          ))}
        </div>

        {/* Community Message */}
        <div className="text-center bg-white rounded-2xl p-8 md:p-12 shadow-lg border border-gray-100">
          <div className="flex justify-center mb-6">
            <MapPin className="w-10 h-10 text-amber-600" />
          </div>
          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-amber-900">
            Redécouvrez et partagez
          </h3>
          <p className="text-xl leading-relaxed max-w-3xl mx-auto text-gray-700">
            <span className="text-amber-700 font-semibold">Redécouvrez ces lieux anodins et partagez vos propres découvertes.</span>
          </p>
        </div>

        {/* Mood Tags Preview */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-amber-900 mb-8">
            Trouvez selon votre humeur
          </h3>
          <div className="flex flex-wrap justify-center gap-3">
            {['Romantique', 'Paisible', 'Contemplatif', 'Inspirant', 'Zen', 'Reposant', 'Spirituel'].map((mood, index) => (
              <span 
                key={index}
                className="px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium hover:bg-amber-200 transition-colors duration-200"
              >
                {mood}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TreasuresSection;